// See https://git.hubteam.com/HubSpotProtected/InboundDbAssociations/blob/master/InboundDbAssociationsModels/src/main/java/com/hubspot/inbounddb/associations/base/AssociationCategory.java
export const HUBSPOT_DEFINED = 'HUBSPOT_DEFINED';
export const USER_DEFINED = 'USER_DEFINED';
export const INTEGRATOR_DEFINED = 'INTEGRATOR_DEFINED';
export const WORK = 'WORK';
export const AssociationCategoryTypesToIds = {
  HUBSPOT_DEFINED: '0',
  USER_DEFINED: '1',
  INTEGRATOR_DEFINED: '2',
  WORK: '3'
};
export const AssociationCategoryIdsToTypes = {
  0: HUBSPOT_DEFINED,
  1: USER_DEFINED,
  2: INTEGRATOR_DEFINED,
  3: WORK
};
export function getCombinedAssociationTypeId(associationDefinition) {
  return `${AssociationCategoryTypesToIds[associationDefinition.category]}-${associationDefinition.id}`;
}
export function getAssociationDefinitionFromCombinedId(combinedAssociationTypeId, associationDefinitions) {
  const [categoryId, typeId] = combinedAssociationTypeId.split('-');
  const associationTypeId = parseInt(typeId, 10);
  return associationDefinitions.find(def => AssociationCategoryTypesToIds[def.category] === categoryId && def.id === associationTypeId);
}
export function getCombinedAssociationTypeIdFromParts(category, associationTypeId) {
  return `${AssociationCategoryTypesToIds[category]}-${associationTypeId}`;
}